import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DataService } from 'src/shared/data/data.service';
// ✅ Custom validator for confirm password
export const passwordMatchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('password')?.value;
  const confirmPassword = control.get('confirmPassword')?.value;
  return password === confirmPassword ? null : { passwordMismatch: true };
};

@Component({
  selector: 'app-my-account-page',
  templateUrl: './my-account-page.component.html',
  styleUrls: ['./my-account-page.component.scss']
})
export class MyAccountPageComponent implements OnInit {
  loginForm!: FormGroup;
  registerForm!: FormGroup;
  activeTab: string = 'login';
  forgotPasswordForm!: FormGroup;
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    public data: DataService) {

  }

  ngOnInit(): void {

    // this.loginForm = this.fb.group({
    //   username: ['', Validators.required],
    //   password: ['', Validators.required]
    // });

    // this.registerForm = this.fb.group({
    //   username: ['', Validators.required],
    //   email: ['', Validators.required],
    //   password: ['', Validators.required], 
    //   confirmPassword: ['', Validators.required]
    // });
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });

    this.registerForm = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      mobile: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/)
      ]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/)
      ]],
      confirmPassword: ['', Validators.required]
    }, { validators: passwordMatchValidator });

this.forgotPasswordForm = this.fb.group({
  email: ['', [Validators.required, Validators.email]]
});
  }

  pageTitle = [
    {
      bgImage: 'assets/img/page-title-bg.jpg',
      title: 'Profile'
    }
  ]

  register() {

    if (this.registerForm.value.password !== this.registerForm.value.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    const payload = {
      username: this.registerForm.value.username,
      email: this.registerForm.value.email,
      password: this.registerForm.value.password,
      mobile:this.registerForm.value.mobile,
    };

    this.http.post<any>(this.data.base_url +'customer_register/', payload)
      .subscribe(res => {
        alert(res.message);
        this.registerForm.reset();
      });
  }

  login() {
    this.http.post<any>(this.data.base_url +'customer_login/', this.loginForm.value)
      .subscribe(res => {

        if (res.status === 1) {

          localStorage.setItem('customer_id', res.user_id);
          localStorage.setItem('customer_name', res.fullname);
          localStorage.setItem('customer_email', res.email);
          localStorage.setItem('is_logged_in', 'true');
          localStorage.setItem('mobile_number', res.mobile);
          localStorage.setItem('profile_image', res.profile_image);

          alert('Login Successful');

          this.router.navigate(['/']);
        }
        else {
          alert(res.message);
        }
      });
  }

forgotPassword(): void {

  if (this.forgotPasswordForm.invalid) {
    return;
  }
  const payload = {
    email: this.forgotPasswordForm.value.email
  };
  this.http.post<any>(
    this.data.base_url + 'send_website_forgot_password_link/',
    payload
  ).subscribe({
    next: (res) => {
      if (res.status === 1) {
        alert('Password reset link sent to your email.');
        this.activeTab = 'login';
      } else {
        alert(res.message);
      }
    },
    error: (err) => {
      console.error(err);
      alert('Something went wrong.');
    }

  });

}

}